import React, { useState } from 'react';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import axios from 'axios';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!executeRecaptcha) {
      console.error('Execute recaptcha not yet available');
      return;
    }

    try {
      const token = await executeRecaptcha('contact_form');
      if (!token) {
        alert('ReCAPTCHA verification failed');
        return;
      }

      const response = await axios.post('/api/contact/submit-form', {
        ...formData,
        token
      });

      // Clear form after successful submission
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: '',
      });

      alert('Message sent successfully!');
    } catch (error) {
      console.error('Error submitting form:', error);
      alert(error.response?.data?.error || error.message || 'An error occurred while submitting the form');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-lg mx-auto mt-8 space-y-6 px-4">
      <div className="text-center mb-8">
        <h2 className="text-4xl font-extrabold text-gray-900">Contact Us</h2>
        <p className="mt-4 text-xl text-gray-600 font-['VVCentra2']">Get in touch with our team</p>
      </div>
      <div>
        <label htmlFor="name" className="block text-sm font-medium text-gray-700">Full Name</label>
        <input
          type="text"
          name="name"
          id="name"
          required
          value={formData.name}
          onChange={handleChange}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
        />
      </div>
      <div>
        <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email Address</label>
        <input
          type="email"
          name="email"
          id="email"
          required
          value={formData.email}
          onChange={handleChange}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
        />
      </div>
      <div>
        <label htmlFor="phone" className="block text-sm font-medium text-gray-700">Phone Number</label>
        <input
          type="tel"
          name="phone"
          id="phone"
          value={formData.phone}
          onChange={handleChange}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
        />
      </div>
      <div>
        <label htmlFor="message" className="block text-sm font-medium text-gray-700">Message</label>
        <textarea
          name="message"
          id="message"
          rows="4"
          required
          value={formData.message}
          onChange={handleChange}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
        ></textarea>
      </div>
      <button
        type="submit"
        className="w-full bg-red-600 text-white py-3 px-6 rounded-lg hover:bg-red-700 transition duration-300 font-['VVCentra2'] font-semibold"
      >
        Send Message
      </button>
    </form>
  );
};

const ContactUs = () => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_VV_CONTEST_RECAPTCHA_SITE_KEY}>
      <ContactForm />
    </GoogleReCaptchaProvider>
  );
};

export default ContactUs;
